module.exports = __webpack_public_path__ + "static/media/emoji-red.923da3b0.svg";